<template>
<div class="container-full-width default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro"
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />

    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
        <span class="lbl-deal-title mb-2 w-100">DISTRIBUIÇÃO POR CFOP</span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />

    <div class="row mb-3 p-5">
        <div class="col-6">
            <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
        </div>
        <div class="col-6">
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio1" class="custom-control-input" value="S" v-model="filtro.operacao">
                    <label class="custom-control-label data-list" for="customRadio1">Saídas (Vendas)</label>
                </div>
            </div>
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio2" class="custom-control-input" value="E" v-model="filtro.operacao">
                    <label class="custom-control-label data-list" for="customRadio2">Entradas</label>
                </div>
            </div>
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio3" class="custom-control-input" value="T" v-model="filtro.operacao">
                    <label class="custom-control-label data-list" for="customRadio3">Todas</label>
                </div>
            </div>
        </div>
    </div>

    <hr>

    <div class="row mb-5" v-if="dados.items && dados.items.length > 0">
        <div class="col-12 lbl-deal-title mb-2">
            RESUMO POR CFOP
            <v-button label="Excel" class="float-right" @click="exportarExcel"></v-button>
            <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
        </div>
        <div class="col-12">
            <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                <div style="overflow: auto">

                    <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100">
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="width:10%" title=""><i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i>CFOP</th>
                                <th class="textual header" style="width:40%" title="">Descrição da Natureza / Operação <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="width:10%" title="">Qtd Notas <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="width:10%" title="">Qtd Itens <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="width:15%" title="">Total Mercadorias <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="width:15%" title="">Total Faturado <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="width:10%" title="">Participação <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="height: 37px" v-for="(row, index) in dados.items" :key="index">
                                <td class="textual">{{ row.cfop }}</td>
                                <td class="textual">{{ row.descricao }}</td>
                                <td class="numerico">{{ row.qtd_notas }}</td>
                                <td class="numerico">{{ row.qtd_itens }}</td>
                                <td class="numerico">{{ row.total_produtos | formatValue(2) }}</td>
                                <td class="numerico">{{ row.total_geral | formatValue(2) }}</td>
                                <td class="numerico">{{ row.participacao | formatValue(2) }}%</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-12" v-if="chartValues.length > 0">
            <!-- <dash-card :params="{ name: 'GRAPH_VENDAS_PEDIDO', chart: { type: 'AreaChart' } }" :filter="filter"></dash-card>  -->
            <chart :params="paramsChart"></chart>
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-12 lbl-deal-title mb-2">
            NOTAS FISCAIS
            <v-button label="Excel" class="float-right" @click="exportarExcelDetalhes"></v-button>
            <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
        </div>
        <div class="col-12" v-if="!dados.detalhes || dados.detalhes.length == 0">
            Nenhuma nota fiscal encontrada
        </div>
        <div v-else class="col-12">
            <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                <div style="overflow: auto">

                    <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100">
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="width:6%" title="">NF</th>
                                <th class="textual header" style="width:4%" title="">Série</th>
                                <th class="textual header" style="width:8%" title="">Data</th>
                                <th class="textual header" style="width:20%" title="">Destinatário</th>
                                <th class="textual header" style="width:12%" title="">Cidade</th>
                                <th class="textual header" style="width:4%" title="">UF</th>
                                <th class="textual header" style="width:6%" title="">CFOP</th>
                                <th class="textual header" style="width:20%" title="">Item</th>
                                <th class="numerico header" style="width:4%" title="">Qtd</th>
                                <th class="numerico header" style="width:8%" title="">Total Item</th>
                                <th class="numerico header" style="width:8%" title="">Total NF</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="height: 37px" v-for="(row, index) in dados.detalhes" :key="index">
                                <td class="textual">{{ row.nf }}</td>
                                <td class="textual">{{ row.serie }}</td>
                                <td class="textual">{{ row.data | formatData }}</td>
                                <td class="textual">{{ row.destinatario }}</td>
                                <td class="textual">{{ row.cidade }}</td>
                                <td class="textual">{{ row.uf }}</td>
                                <td class="textual">{{ row.cfop }}</td>
                                <td class="textual">{{ row.item_desc }}</td>
                                <td class="numerico">{{ row.qtuni }}</td>
                                <td class="numerico">{{ row.total_item | formatValue(2) }}</td>
                                <td class="numerico">{{ row.total_nf | formatValue(2) }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import DashCard from '../dashboards/dash-card'
import Chart from './chart'
import Filtro from './filtro'
import { apiORDSpost } from '../shared/api-functions'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { formatValue } from '../shared/utils'

export default {
    name: 'ConsultaDistribuicaoCfop',
    components: {
        DashCard,
        Filtro,
        Chart,
    },

    data() {
        return {
            showfiltro: false,

            dados: {
                grafico: [],
                items: [],
                detalhes: [],
            },

            paramsFiltro: {
                periodo: {
                    label: 'Período de Emissão',
                    varios: false,
                    data_inicio: null,
                    data_termino: null,
                },
                filtros: [
                    { nome: 'cliente', label: 'Cliente / Destinatário', url: null, varios: true, values: [] },
                    { nome: 'filial', label: 'Filial', url: null, varios: false, values: [] },
                ],
            },

            filtro: {
                operacao: 'S',
                periodos: [{ data_inicio: null, data_termino: null }],
            },
        }
    },

    watch: {
        'filtro.operacao': function () {
            this.loadData()
        },
    },

    computed: {
        paramsChart() {
            return {
                chart: { type: 'PieChart' },
                values: this.chartValues,
            }
        },

        chartValues() {
            if (!this.dados || !this.dados.grafico || this.dados.grafico.length <= 1) {
                return []
            }
            return this.dados.grafico
        },
    },

    methods: {
        handleCloseFiltro() {
            this.showfiltro = false
        },

        clickRetornar() {
            this.$router.push('/')
        },

        handleShowFiltro() {
            this.showfiltro = true
        },

        filtroChange(filtro) {
            this.showfiltro = false
            this.filtro = {
                ...this.filtro,
                ...filtro,
                periodos: filtro.periodos || this.filtro.periodos,
            }

            if (this.filtro.periodos && this.filtro.periodos[0]) {
                this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio
                this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino
            }

            this.loadData()
        },

        async loadData() {
            const payload = {
                periodos: this.filtro.periodos,
                operacao: this.filtro.operacao,
                data_inicio: this.filtro.periodos && this.filtro.periodos[0] ? this.filtro.periodos[0].data_inicio : null,
                data_termino: this.filtro.periodos && this.filtro.periodos[0] ? this.filtro.periodos[0].data_termino : null,
                cliente: this.filtro.cliente,
                filial: this.filtro.filial,
            }

            const res = await apiORDSpost(this.$store, 'consulta/vendas/distribuicaocfop', payload, 'post')
            if (res) {
                this.dados = {
                    grafico: res.grafico || [],
                    items: res.items || [],
                    detalhes: res.detalhes || [],
                }
            } else {
                this.dados = {
                    grafico: [],
                    items: [],
                    detalhes: [],
                }
            }
        },

        exportarExcel() {
            if (!this.dados || !this.dados.items || this.dados.items.length === 0) return

            const exportList = this.dados.items.map(item => ({
                CFOP: item.cfop,
                Descricao: item.descricao,
                Qtd_Notas: item.qtd_notas,
                Qtd_Itens: item.qtd_itens,
                Total_Mercadorias: formatValue(item.total_produtos, 2),
                Total_Faturado: formatValue(item.total_geral, 2),
                Participacao_Perc: formatValue(item.participacao, 2) + '%',
            }))

            const csv = objectToCsv(exportList)
            downloadCsvReport(csv)
        },

        exportarExcelDetalhes() {
            if (!this.dados || !this.dados.detalhes || this.dados.detalhes.length === 0) return

            const exportList = this.dados.detalhes.map(item => ({
                NF: item.nf,
                Serie: item.serie,
                Data: item.data,
                Destinatario: item.destinatario,
                Cidade: item.cidade,
                UF: item.uf,
                CFOP: item.cfop,
                Item: item.item_desc,
                Qtd: item.qtuni,
                Total_Item: formatValue(item.total_item, 2),
                Total_NF: formatValue(item.total_nf, 2),
            }))

            const csv = objectToCsv(exportList)
            downloadCsvReport(csv)
        },
    },

    created() {
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())

        if (this.$route.query.data_inicio) {
            this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio)
            this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino)
        } else if (this.$route.query.startDate) {
            this.filtro.periodos[0].data_inicio = this.$route.query.startDate
            this.filtro.periodos[0].data_termino = this.$route.query.endDate
        }

        this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio
        this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino

        this.loadData()
    },
}
</script>

<style>

table .numerico {
    min-width:65px;
    text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-distribuicao-cfop.vue